export default __webpack_public_path__ + "static/telegram_logo-87071a5682b3776809a7de9a73fa722c.svg";